import { Tooltip } from 'antd';
import { AbstractTooltipProps } from 'antd/lib/tooltip';
import classNames from 'classnames';
import { upperCase } from 'lodash-es';
import { getHashedColor } from 'utils/color';
import './NameBadge.less';

type BadgeColor = 'blue' | 'green' | 'pink' | 'purple' | 'yellow';
type BadgeSize = 'small' | 'large';
interface Props extends AbstractTooltipProps {
  name: string;
  color?: BadgeColor;
  size?: BadgeSize;
}

const NameBadge = ({ name, color, size = 'small', ...props }: Props) => {
  const nameArr = name.split(' ');
  const firstName = nameArr[0][0];
  const lastName = nameArr[nameArr.length - 1][0];

  return (
    <Tooltip
      getPopupContainer={(e) => {
        return e as HTMLElement;
      }}
      {...props}
      title={name}
    >
      <span
        className={classNames('revx-name-badge', color, size)}
        style={color ? {} : { backgroundColor: getHashedColor(name) }}
      >
        <span>{upperCase(firstName)}</span>
        <span>{upperCase(lastName)}</span>
      </span>
    </Tooltip>
  );
};

const NAME_BADGE_COLORS: BadgeColor[] = [
  'blue',
  'green',
  'pink',
  'purple',
  'yellow',
];
const getBadgeColor = (index: number) => {
  return NAME_BADGE_COLORS[index % 5];
};

export { getBadgeColor, NameBadge, NAME_BADGE_COLORS };

export default NameBadge;
